import styled from 'styled-components';

export const BlogContainer = styled.main`
  margin: 0 auto;
  padding: 225px 60px 25px;

  @media (max-width: 768px) {
    width: min(100% - 24px, 1180px);
    padding: 100px 20px 20px;
  }
`;

export const BlogHero = styled.header`
  margin-bottom: 48px;

  p {
    margin: 0 0 8px;
    color: var(--blue-dark-1);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.6px;
  }

  h1 {
    margin: 0 0 12px;
    color: var(--dark-shade-2);
    font-size: 64px;
  }

  span {
    display: block;
    max-width: 720px;
    color: var(--dark-shade-1);
    font-size: 20px;
  }
`;

export const BlogGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 28px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const BlogPostCard = styled.article`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--blue-light-2);
  border-radius: 24px;
  background: var(--white);
  box-shadow: 0 18px 45px rgba(37, 124, 182, 0.08);
`;

export const BlogPostImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 10;
  object-fit: cover;
`;

export const BlogPostText = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 24px;

  h2 {
    margin: 0 0 12px;
    font-size: 26px;
    line-height: 1.2;
  }

  h2 a {
    color: var(--dark-shade-2);
    text-decoration: none;
  }

  p {
    margin: 0 0 24px;
    color: var(--dark-shade-1);
  }

  .read-more {
    margin-top: auto;
    color: var(--blue-dark-1);
    font-weight: 700;
    text-decoration: none;
  }
`;

export const BlogPostMeta = styled.span`
  display: block;
  margin-bottom: 12px;
  color: var(--blue-dark-1);
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const BlogPostArticle = styled.article`
  width: min(100% - 24px, 1180px);
  margin: 0 auto;

  .back-link {
    display: inline-block;
    margin-bottom: 32px;
    color: var(--blue-dark-1);
    font-weight: 700;
    text-decoration: none;
  }
`;

export const BlogPostHeader = styled.header`
  margin-bottom: 32px;

  h1 {
    margin: 0 0 16px;
    color: var(--dark-shade-2);
    font-size: 64px;
  }

  p {
    margin: 0;
    color: var(--dark-shade-1);
    font-size: 20px;
  }
`;

export const BlogPostHeroImage = styled.img`
  width: 100%;
  max-height: auto;
  margin-bottom: 42px;
  border-radius: 24px;
  object-fit: cover;
`;

export const BlogPostBody = styled.div`
  color: var(--dark-shade-2);
  font-size: 18px;
  line-height: 1.75;

  p,
  ul,
  ol,
  blockquote {
    margin: 0 0 22px;
  }

  h2,
  h3,
  h4 {
    margin: 42px 0 16px;
    color: var(--dark-shade-2);
  }

  a {
    color: var(--blue-dark-1);
  }

  img {
    max-width: 100%;
    margin: 24px 0;
    border-radius: 18px;
  }

  blockquote {
    padding: 18px 24px;
    border-left: 4px solid var(--blue-dark-1);
    background: var(--blue-light-1);
  }
`;

export const RelatedPosts = styled.section`
  margin-top: 56px;
  padding-top: 32px;
  border-top: 1px solid var(--blue-light-2);

  h2 {
    margin: 0 0 18px;
    font-size: 32px;
  }

  ul {
    margin: 0;
    padding-left: 20px;
  }

  a {
    color: var(--blue-dark-1);
    font-weight: 700;
    text-decoration: none;
  }
`;
